import React from 'react';
import './App.css';
import Home from './components/HomeComponent';

function App() {
  return (
    <Home />
  );
}

export default App;
